(function() {
    'use strict';

    angular
        .module('cloudApp')
        .controller('PasswordController', PasswordController);

    PasswordController.$inject = ['Auth', 'Principal', 'password_pattern'];

    function PasswordController (Auth, Principal, passwordPattern) {
        var vm = this;

        vm.changePassword = changePassword;
        vm.doNotMatch = null;
        vm.error = null;
        vm.success = null;
        vm.success = null;
        vm.passwordExcudedEmailPattern = null;

        Principal.identity().then(function(account) {
            vm.account = account;
        });

        function changePassword () {
            if (vm.password !== vm.confirmPassword) {
                vm.error = null;
                vm.success = null;
                vm.doNotMatch = 'ERROR';
            } else {
                vm.doNotMatch = null;
                Auth.changePassword(vm.oldPassword, vm.password).then(function () {
                    vm.error = null;
                    vm.success = 'OK';
                }).catch(function () {
                    vm.success = null;
                    vm.error = 'ERROR';
                });
            }
        }

        vm.getPasswordPattern = function () {
            if (vm.account.email) {
                if (!vm.passwordExcudedEmailPattern) {
                    var passPattern = passwordPattern + "";
                    vm.passwordExcudedEmailPattern = new RegExp(passPattern.slice(1, -1) + "(?!.*" + vm.account.email + ")");
                }
                return vm.passwordExcudedEmailPattern;

            } else {
                return passwordPattern;
            }
        }
    }
})();
